export default {
  header: 'Tetthet',
  og: 'OG',
  sg: 'SG',
  fg: 'FG',
};
